import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { STACK_WEBHOOKS_COLUMN_ID } from "../constants";
import { WebhookIntegrationWithTimestamp } from "../types";
import StackWebhooksTableCreatedAtCell from "./CreatedAtCell";
import StackWebhooksTableDropdownCell from "./DropdownCell";
import StackWebhooksTableEndpointCell from "./EndpointCell";
import StackWebhooksTableStatusCell from "./StatusCell";

export const STACK_WEBHOOKS_TABLE_CELLS: TableCellPerColumn<WebhookIntegrationWithTimestamp> = {
  [STACK_WEBHOOKS_COLUMN_ID.ENDPOINT]: StackWebhooksTableEndpointCell,
  [STACK_WEBHOOKS_COLUMN_ID.STATUS]: StackWebhooksTableStatusCell,
  [STACK_WEBHOOKS_COLUMN_ID.CREATED_AT]: StackWebhooksTableCreatedAtCell,
  [STACK_WEBHOOKS_COLUMN_ID.DROPDOWN]: StackWebhooksTableDropdownCell,
};
